import DataImplementation from './DataImplementation.js';
import DataImplementationNormalization from './DataImplementationNormalization.js';
import DataImplementationOverride from './DataImplementationOverride.js';
import DataImplementationSelection from './DataImplementationSelection.js';
import DataRecord from './DataRecord.js';
import DataRecordUtils from './DataRecordUtils.js';
import DataReference from './DataReference.js';
import DataReferenceCollection from './DataReferenceCollection.js';
import DataReferenceQuery from './DataReferenceQuery.js';
import DataReferenceSourceType from './DataReferenceSourceType.js';
import fromDataReferenceProps from './fromDataReferenceProps.js';
import hydrateImplementationFromReferences from './hydrateImplementationFromReferences.js';
import NormalizedDataReference from './NormalizedDataReference.js';
/**
 * @namespace data-references
 */
const data = {
    DataImplementation,
    DataImplementationNormalization,
    DataImplementationOverride,
    DataImplementationSelection,
    DataRecord,
    DataRecordUtils,
    DataReference,
    DataReferenceCollection,
    DataReferenceQuery,
    DataReferenceSourceType,
    fromDataReferenceProps,
    hydrateImplementationFromReferences,
    NormalizedDataReference,
};
export { DataImplementation, DataImplementationNormalization, DataImplementationOverride, DataImplementationSelection, DataRecord, DataRecordUtils, DataReference, DataReferenceCollection, DataReferenceQuery, DataReferenceSourceType, fromDataReferenceProps, hydrateImplementationFromReferences, NormalizedDataReference, };
export default data;
